import React from 'react';

import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';

import AutomationFileConfigEditorTransformsSection from '../AutomationFileConfigEditorTransformsSection';
import AutomationFileConfigFileFormatInput from '../AutomationFileConfigFileFormatInput';
import {AutomationOutputFileConfigEditorProps} from '../AutomationFileConfigUtils';
import {labAutomationFileExtensionOptions} from '../RunSchemaSpecConstants';

export default function AutomationOutputFileConfigEditorTransformsSection(
  props: AutomationOutputFileConfigEditorProps
): JSX.Element {
  return (
    <AutomationFileConfigEditorTransformsSection
      automationFileConfig={props.outputFileConfig}
      baseSchema={props.baseSchema}
      configFileType="output"
      description="(Optional) Transform your file into a format that Benchling can process."
      onUpdateConfig={props.onUpdateConfig}
      sectionNumber={3}
      title="Apply transforms to the output file"
      allowPreview={true}
    >
      <FieldLabel label="File extension for intermediate files" labelStyle={LabelStyle.LABEL} />
      <br />
      <AutomationFileConfigFileFormatInput
        label="File extension"
        options={labAutomationFileExtensionOptions}
        value={props.outputFileConfig.fileExtension}
        onSelect={(value: string) => {
          props.onUpdateConfig({
            ...props.outputFileConfig,
            fileExtension: value,
          });
        }}
      />
    </AutomationFileConfigEditorTransformsSection>
  );
}
